// istanbul ignore file
import { registerDefaultsForModule } from '@glu/theming';
import ash from './themes/ashTheme';

const defaultTheme = (theme) => ash(theme);

registerDefaultsForModule('nav', defaultTheme);
